import * as React from "react";

export const ListEditIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.5} clipPath="url(#a)" fill="currentColor">
      <path d="M11.875 0H2.292A2.29 2.29 0 0 0 0 2.292v12.916A2.29 2.29 0 0 0 2.292 17.5h6.15l.183-1.025c.083-.467.3-.883.633-1.225l4.909-4.9V2.292A2.29 2.29 0 0 0 11.875 0M3.333 3.333h3.334c.458 0 .833.375.833.834A.836.836 0 0 1 6.667 5H3.333a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834M7.5 11.667H3.333a.836.836 0 0 1-.833-.834c0-.458.375-.833.833-.833H7.5c.458 0 .833.375.833.833a.836.836 0 0 1-.833.834m3.333-3.334h-7.5A.836.836 0 0 1 2.5 7.5c0-.458.375-.833.833-.833h7.5c.459 0 .834.375.834.833a.836.836 0 0 1-.834.833m-.393 11.669a.623.623 0 0 1-.616-.735l.442-2.504a.63.63 0 0 1 .173-.333l6.188-6.187c.76-.761 1.506-.556 1.915-.147l1.03 1.03a1.46 1.46 0 0 1 0 2.063l-6.187 6.188a.6.6 0 0 1-.333.173l-2.504.442a1 1 0 0 1-.109.01" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
